import React, {useEffect} from 'react'
import {Layer, Line, Rect, Stage} from "react-konva";
import SnapRectangle from "./shapes/snap-rectangle";
import Konva from "konva";

const stageWidth = window.innerWidth * 3 / 4;
const stageHeight = window.innerHeight * 3 / 4;
const shadowOffset = 20;
const tween = null;
const blockSnapSize = 30;

function generateShapes() {
    // first generate random rectangles
    return [...Array(2)]
        .map((_, index) => ({
            /*id: 'image-' + index,
            x: Math.random() * stageWidth,
            y: Math.random() * stageHeight,
            width: 100 + (index * 50),
            height: 100 + (index * 50),
            imageUrl: 'assets/images/background/space-splash001.png',
            draggable: true,
            name: 'object',*/
            x: Math.random() * stageWidth,
            y: Math.random() * stageHeight,
            width: blockSnapSize * 6,
            height: blockSnapSize * 3,
            fill: Konva.Util.getRandomColor(),
            stroke: '#ddd',
            strokeWidth: 1,
            shadowColor: 'black',
            shadowBlur: 2,
            shadowOffset: {x: 1, y: 1},
            shadowOpacity: 0.4,
            draggable: true
        }));
}

function generateGrid() {
    const padding = blockSnapSize;
    const gridLines = [];
    for (let i = 0; i < stageWidth / padding; i++) {
        gridLines.push({
            points: [Math.round(i * padding) + 0.5, 0, Math.round(i * padding) + 0.5, stageHeight],
            stroke: '#ddd',
            strokeWidth: 1,
        });
    }

    return gridLines;
}

function generateGridLinesY() {
    const padding = blockSnapSize;
    const gridLinesY = [];
    for (let j = 0; j < stageHeight / padding; j++) {
        gridLinesY.push({
            points: [0, Math.round(j * padding), stageWidth, Math.round(j * padding)],
            stroke: '#ddd',
            strokeWidth: 0.5,
        });
    }

    return gridLinesY;
}

const INITIAL_SHAPES = generateShapes();
const GRID_LINES = generateGrid();
const GRID_LINES_Y = generateGridLinesY();

const SnapGridTransformer = () => {
    const stageRef = React.useRef(null);
    const layerRef = React.useRef(null);
    const gridLayerRef = React.useRef(null);
    // const rectangleRef = React.useRef(null);
    const shadowRectangleRef = React.useRef(null);

    const [rectangles, setRectangles] = React.useState(INITIAL_SHAPES);
    const [gridLines, setGridLines] = React.useState(GRID_LINES);
    const [gridLinesY, setGridLinesY] = React.useState(GRID_LINES_Y);

    useEffect(() => {
        shadowRectangleRef.current.hide();
    })

    const handleDragStart = (event) => {
        shadowRectangleRef.current.show();
        shadowRectangleRef.current.moveToTop();

        const rectangleRef = event.target;
        rectangleRef.moveToTop();
    }

    const handleDragEnd = (event) => {
        const rectangleRef = event.target;

        rectangleRef.position({
            x: Math.round(rectangleRef.x() / blockSnapSize) * blockSnapSize,
            y: Math.round(rectangleRef.y() / blockSnapSize) * blockSnapSize
        });
        stageRef.current.batchDraw();
        shadowRectangleRef.current.hide();
    }

    const handleDragMove = (event) => {
        const rectangleRef = event.target;

        shadowRectangleRef.current.position({
            x: Math.round(rectangleRef.x() / blockSnapSize) * blockSnapSize,
            y: Math.round(rectangleRef.y() / blockSnapSize) * blockSnapSize
        });
        stageRef.current.batchDraw();
    }

    return (
        <>
            <Stage width={window.innerWidth * 3 / 4} height={window.innerHeight * 3 / 4}
                   ref={stageRef}
                   className="">

                <Layer ref={gridLayerRef}>
                    {gridLines.map((gridLine, i) => {
                        return (
                            <Line
                                key={i}
                                {...gridLine}
                            />
                        )
                    })}
                    <Line points={[0, 0, 10, 10]}/>
                    {gridLinesY.map((gridLine, i) => {
                        return (
                            <Line
                                key={i}
                                {...gridLine}
                            />
                        )
                    })}
                </Layer>

                <Layer ref={layerRef}>
                    <Rect
                        ref={shadowRectangleRef}
                        x={0}
                        y={0}
                        width={blockSnapSize * 6}
                        height={blockSnapSize * 3}
                        fill={'#FF7B17'}
                        opacity={0.6}
                        stroke={'#CF6412'}
                        strokeWidth={3}
                        dash={[20, 2]}
                    />
                    {rectangles.map((rect, i) => {
                        return (
                            <SnapRectangle
                                key={i}
                                shapeProps={rect}
                                layer={layerRef.current}
                                stage={stageRef.current}
                                blockSnapSize={blockSnapSize}
                                handleDragStart={handleDragStart}
                                handleDragEnd={handleDragEnd}
                                handleDragMove={handleDragMove}
                            />
                        )
                    })}
                </Layer>

            </Stage>
        </>
    )
}

export default SnapGridTransformer
